import React from 'react';
import { useMedia } from 'react-use';
import { Swiper, SwiperSlide } from 'swiper/react';

import IconBox from '../iconBox/IconBox';
import styles from '@srcDS/components/molecules/featuredFilterList/FeaturedFilterList.module.scss';
import { swiperParams } from './utils';
import { usePathname } from 'next/navigation';

import { Reference } from '@apgnext/frontend/types/reference';
import { ImageProps } from '@apgnext/frontend/types/image';

interface FeaturedFilterItem {
  categoryAvatar?: ImageProps;
  title?: string;
  reference: Reference;
}

interface FeaturedFilterListProps {
  list: FeaturedFilterItem[];
}

const ITEMS_THRESHOLD = 7;

const FeaturedFilterList: React.FC<FeaturedFilterListProps> = ({ list }) => {
  const pathname = usePathname();

  const isMobile = useMedia('(max-width: 1024px)', false);
  const itemsQuantity = list.length;
  const swiperEnabled = isMobile || itemsQuantity > ITEMS_THRESHOLD;

  const elements = list.map((it: FeaturedFilterItem, index: number) => {
    const isActive =
      (it.reference.type === 'link' && it.reference.link === pathname) ||
      (it.reference.type === 'page-folder' && it.reference.pageFolder._url === pathname);

    const iconBox = (
      <div className={styles.icons} key={index}>
        <IconBox
          /*@ts-ignore*/
          image={it.categoryAvatar}
          link={{ reference: it.reference, title: it.title }}
          isActive={isActive}
          {...it}
        />
      </div>
    );

    return swiperEnabled ? <SwiperSlide key={index}>{iconBox}</SwiperSlide> : iconBox;
  });

  return (
    <div className={styles.root}>
      {swiperEnabled && <Swiper {...swiperParams}>{elements}</Swiper>}
      {!swiperEnabled && elements}
    </div>
  );
};

export default FeaturedFilterList;
